import { RootState } from 'store/types';
import { createSelector } from 'reselect';

export const providerSuggestionsStateSelector = (state: RootState) =>
  state.providerSearch.providerSuggestions;

export const providerSuggestionsDataSelector = createSelector(
  providerSuggestionsStateSelector,
  s => s.data.providers
);

export const locationSuggestionsDataSelector = createSelector(
  providerSuggestionsStateSelector,
  s => s.data.locations
);
